import * as actions from '../../redux/actions';
import HeroSection from '../../common/HeroSection/HeroSection';
import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import destinationBanner from '../../assets/tepual/destinations/destination-main.jpg';
import getSlides from '../../functions/getSlides/getSlides';
import MultiSlider3 from '../../common/MultiSlider/MultiSlider3';
import { AndimarTitle } from '../../common/Title/AndimarTitle';
import getIcons from '../../functions/getIcons/getIcons';
import CommonService from '../../../../services/commonService';
import KuposTabs from '../../../common/KuposTabs';
import KuposHelmet from '../../../common/KuposHelmet';
import ThemeTenTitle from '../components/ThemeTenTitle';

const firstFloor = [
  ' Sensor fatiga y somnolencia',
  'Sensor cambio de carril',
  'Sensor exceso de velocidad',
];
const secondFloor = [' Velocímetro visible', 'Monitoreo por GPS', 'Cámaras de seguridad'];

const ThemeTenTravelNorth = props => {
  const operator = CommonService.getLocal('op') || props.home.operator;

  const takeCareIconsTraveltur = [
    {
      text: (
        <span>
          <strong> Servicios de transporte</strong>
          <br />a la minería
        </span>
      ),
      image: getIcons('ammenity1', operator),
    },
    {
      text: (
        <span>
          Buses de
          <strong>
            {' '}
            última <br /> generación{' '}
          </strong>
        </span>
      ),
      image: getIcons('ammenity2', operator),
    },
    {
      text: (
        <span>
          <strong> Contratos y convenios</strong>
          <br />
          <span>especiales</span>
        </span>
      ),
      image: getIcons('ammenity3', operator),
    },
  ];

  const initalState = {
    selectedTab: 1,
  };

  const styles = {
    singleTab: {
      marginTop: 40,
      background: operator && operator.theme_color2,
      padding: 15,
      justifyContent: 'center',
      color: '#fff',
      borderTopLeftRadius: 50,
      borderBottomLeftRadius: 50,
    },
    interCityContainer: {
      background: '#F3F7FF',
      // height: 300,
      marginTop: -20,
      borderRadius: 10,
      paddingTop: 50,
      paddingLeft: 100,
      paddingRight: 100,
      paddingBottom: 30,
    },
  };

  return (
    <div>
      <KuposHelmet />
      <HeroSection
        heroImage={getIcons('NorteBanner', operator)}
        height={'41vh'}
        title={'Travel Norte'}
        description={'Home / Travel Norte'}
        marginTop="-50px"
      />
      <div>
        <ThemeTenTitle title={'TRANSPORTE PARA LA MINERÍA'} />
        <div className="new-container">
          <div className="light-grey-background"></div>
          <div className="take-care d-flex " style={{ justifyContent: 'space-around' }}>
            {takeCareIconsTraveltur.map(item => (
              <div
                className="take-care-item d-flex flex-column align-items-center text-center"
                style={{ width: '25%' }}
              >
                <img src={item.image} alt="" />
                <p className="mt-2">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        style={{ marginTop: 60, gap: 20, marginLeft: '10%' }}
        className="d-flex font10 montserrat"
      >
        <div className="font11 montserrat y-kupos-value" style={{ flex: 1 }}>
          Nuestros modernos buses, con salidas periódicas hacia ciudades como Calama y Antofagasta,
          están configurados para acceder con facilidad a las faenas mineras. Son vehículos
          acondicionados especialmente en cuanto a performance, seguridad, conectividad y confort.
          <br />
          <br />
          El transporte de personal hacia y dentro de las faenas ofrece a las compañias mineras
          importantes desafíos de logística, seguridad y bienestar de su personal que influyen
          significativamente en la viabilidad de sus operaciones.
          <br />
          <br />
          Por otro lado, la preparación y pericia de nuestros choferes y controladores es vital al
          manejar un bus de 14 metros de longitud o más, en alta cordillera y con nieve, y es por
          tanto un tema de suprema importancia. Para ello nos aseguramos que posean capacitaciones
          al día y suficiente experiencia.
        </div>
        <div style={{ flex: 1 }}>
          <img src={getIcons('AmenitiesRightImage', operator)} alt="" />
        </div>
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeTenTravelNorth);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTen/ThemeTenPages/ThemeTenTravelNorth.js